/* eslint-disable no-unused-vars */
import { createAPIHandler } from "@/plugins/ofetch";
import downloadUrl from "@/utils/downloadUrl.js";

const _LogoutAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/auth/logout.js").logout>}  */
  logout: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/auth/logout`,
      { method: "GET", query }
    ]
  ),
};
export { _LogoutAPI as LogoutAPI };
const _WhoAmIAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/auth/who-am-i.js").whoAmI>}  */
  whoAmI: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/auth/who-am-i`,
      { method: "GET", query }
    ]
  ),
};
export { _WhoAmIAPI as WhoAmIAPI };
